import { defineComponent as _defineComponent } from 'vue'
import Icon from "../../../../common/Icon.vue";
import playIcon from "../../../../../assets/icon/video-play.png";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-abstract-video',
  props: {
  messageContent: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props



return { __sfc: true,props, Icon, playIcon }
}

})